// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__OS6jz","rotate":"Loader_rotate__5aFgA"};